// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdvanceController from "./advance_controller"
application.register("advance", AdvanceController)

import AnimatedNumberController from "./animated_number_controller"
application.register("animated-number", AnimatedNumberController)

import AutoNavigateController from "./auto_navigate_controller"
application.register("auto-navigate", AutoNavigateController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import BulkExports__FilenamePatternController from "./bulk_exports/filename_pattern_controller"
application.register("bulk-exports--filename-pattern", BulkExports__FilenamePatternController)

import CardCarouselController from "./card_carousel_controller"
application.register("card-carousel", CardCarouselController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CheckKindController from "./check_kind_controller"
application.register("check-kind", CheckKindController)

import CheckPreviewController from "./check_preview_controller"
application.register("check-preview", CheckPreviewController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import DataAttributeController from "./data_attribute_controller"
application.register("data-attribute", DataAttributeController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DocumentUploadsController from "./document_uploads_controller"
application.register("document-uploads", DocumentUploadsController)

import DropdownPopoverController from "./dropdown_popover_controller"
application.register("dropdown-popover", DropdownPopoverController)

import EventsController from "./events_controller"
application.register("events", EventsController)

import FakeAiChatController from "./fake_ai_chat_controller"
application.register("fake-ai-chat", FakeAiChatController)

import FieldsetSwitchController from "./fieldset_switch_controller"
application.register("fieldset-switch", FieldsetSwitchController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HeadroomController from "./headroom_controller"
application.register("headroom", HeadroomController)

import InsertTextController from "./insert_text_controller"
application.register("insert-text", InsertTextController)

import MarqueeController from "./marquee_controller"
application.register("marquee", MarqueeController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MirrorController from "./mirror_controller"
application.register("mirror", MirrorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NameStepController from "./name_step_controller"
application.register("name-step", NameStepController)

import OffscreenToastController from "./offscreen_toast_controller"
application.register("offscreen-toast", OffscreenToastController)

import PositionsController from "./positions_controller"
application.register("positions", PositionsController)

import PreserveXScrollController from "./preserve_x_scroll_controller"
application.register("preserve-x-scroll", PreserveXScrollController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import ReloadingImageController from "./reloading_image_controller"
application.register("reloading-image", ReloadingImageController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ResponsivePreviewController from "./responsive_preview_controller"
application.register("responsive-preview", ResponsivePreviewController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import ScrollToRightController from "./scroll_to_right_controller"
application.register("scroll-to-right", ScrollToRightController)

import SearchableDropdownController from "./searchable_dropdown_controller"
application.register("searchable-dropdown", SearchableDropdownController)

import SelectionFrameController from "./selection_frame_controller"
application.register("selection-frame", SelectionFrameController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import SlugController from "./slug_controller"
application.register("slug", SlugController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateController from "./template_controller"
application.register("template", TemplateController)

import TemplateFakeDestroyController from "./template_fake_destroy_controller"
application.register("template-fake-destroy", TemplateFakeDestroyController)

import TemplatePrinterController from "./template_printer_controller"
application.register("template-printer", TemplatePrinterController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToggleRadioController from "./toggle_radio_controller"
application.register("toggle-radio", ToggleRadioController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UnhideController from "./unhide_controller"
application.register("unhide", UnhideController)

import VideoViewportController from "./video_viewport_controller"
application.register("video-viewport", VideoViewportController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
